import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function AdminPanel() {
  const [stats, setStats] = useState(null);
  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data));
    api.get("/admin/organizations").then(({ data }) => setOrgs(data));
  }, []);

  if (!stats) return <div>Caricamento…</div>;

  return (
    <div className="space-y-6" data-testid="admin-page">
      <div>
        <div className="label-tag">Super Admin</div>
        <h1 className="font-display text-4xl font-bold tracking-tight text-slate-900 mt-1">Pannello globale</h1>
      </div>

      <div className="grid grid-cols-4 gap-4">
        <Card className="card-flat p-5"><div className="label-tag">Organizzazioni</div><div className="data-num text-3xl font-semibold mt-2">{stats.organizations}</div></Card>
        <Card className="card-flat p-5"><div className="label-tag">Utenti</div><div className="data-num text-3xl font-semibold mt-2">{stats.users}</div></Card>
        <Card className="card-flat p-5"><div className="label-tag">Rischi mappati</div><div className="data-num text-3xl font-semibold mt-2">{stats.risks_mapped}</div></Card>
        <Card className="card-flat p-5"><div className="label-tag">Controlli</div><div className="data-num text-3xl font-semibold mt-2">{stats.controls}</div></Card>
      </div>

      <Card className="card-flat overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b text-xs uppercase tracking-wider text-slate-600">
            <tr><th className="py-3 px-3 text-left">Organizzazione</th><th className="py-3 px-3 text-left">Settore</th><th className="py-3 px-3 text-left">Piano</th><th className="py-3 px-3 text-left">PMI</th><th className="py-3 px-3 text-left">Setup</th></tr>
          </thead>
          <tbody>
            {orgs.map((o) => (
              <tr key={o.id} className="border-b border-slate-100">
                <td className="py-3 px-3 text-slate-900">{o.name}</td>
                <td className="py-3 px-3 text-slate-600">{o.industry}</td>
                <td className="py-3 px-3"><span className="text-xs">{o.subscription_tier}</span></td>
                <td className="py-3 px-3">{o.is_pmi ? "Sì" : "No"}</td>
                <td className="py-3 px-3">{o.setup_completed ? "✓" : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
